import { Image as ReactNativeImage } from "react-native";
import { applyAssetSourcePatch } from "./asset-source-patch.ts";

// Fixes RN's iOS asset-server URL builder for monorepo-resolved assets with
// non-ASCII filenames. See asset-source-patch.ts.
applyAssetSourcePatch();

export {
  AccessibilityInfo,
  ActivityIndicator,
  Alert,
  Animated,
  AppState,
  BackHandler,
  DeviceEventEmitter,
  DevSettings,
  Dimensions,
  Keyboard,
  KeyboardAvoidingView,
  Linking,
  LogBox,
  Modal,
  NativeModules,
  PanResponder,
  PixelRatio,
  Platform,
  PlatformColor,
  Pressable,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  Vibration,
  View,
  processColor,
} from "react-native";
export { useWindowDimensions } from "./use-window-dimensions.ts";
export type * from "react-native";

/** For asset URL patching only — use `@-/com.npmjs.expo-image` for the Image component. */
export const resolveAssetSource = ReactNativeImage.resolveAssetSource;
